// #ifdef H5
import { createApp } from 'vue';
import LetterPopup from '@/components/letter-popup/letter-popup.vue';
import i18n from '@/locale/index.js';
import { pinia } from '@/stores/pinia.js';

let mounted = false;

// 把站内信弹窗作为独立实例挂到 body，使其脱离具体页面、任意页面都能弹出
// 复用主 app 的 pinia / i18n 实例，确保读到同一个 letter store、跟随语言切换
export function mountLetterPopup() {
	if (mounted) return;
	mounted = true;
	const host = document.createElement('div');
	host.id = 'letter-popup-root';
	document.body.appendChild(host);

	const app = createApp(LetterPopup);
	app.use(pinia);
	app.use(i18n);
	app.mount(host);
}
// #endif
